
import { Link } from "react-router-dom";
import { FaBars } from "react-icons/fa";
import { cloneElement } from "react";

const BreadCrumbs = ({ breadcrumbs = [] }) => {
  return (
    <div className="w-100 rounded-2 bg-white border p-3">
      <div className="d-flex flex-row align-items-center flex-wrap">
         

        {breadcrumbs.map((breadcrumb, index) => {
          const isLastItem = index === breadcrumbs.length - 1;
          
          const renderIcon = () => {
            if (breadcrumb.icon) {
              return cloneElement(breadcrumb.icon, {
                className: "me-3",
                size : 18
              });
            }
            return <FaBars className="me-2" size={15} />;
          };
          return (
            <div key={index} className="d-flex align-items-center">
              {index > 0 && <span className="mx-4 text-secondary">/</span>}

              {isLastItem ? (
                <span
                  className="d-flex align-items-center"
                  style={{ fontSize: "14px", color: "#C72430", fontWeight : 600}}
                >
                  {renderIcon()}
                  {breadcrumb.text}
                </span>
              ) : (
                <Link
                  to={breadcrumb.href}
                  className="d-flex align-items-center text-secondary text-decoration-none"
                  style={{ fontSize: "14px" }}
                //   onClick={() => setLastClicked(breadcrumb.text)}
                >
                  {renderIcon()}
                  {breadcrumb.text}
                </Link>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BreadCrumbs;
